import React from "react";
import Chart from "react-apexcharts";
import { useWindowSize } from "react-use";

import PropTypes from "prop-types";

import Ledgeritempositive from "./ledgeritempositive";
import Ledgeritemnegative from "./ledgeritemnegative";
import "./ledger_view.css";

const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }
  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }
  render() {
    if (this.state.errorInfo) {
      return <div></div>;
    }
    return this.props.children;
  }
}

export function numerizeFloat(value) {
  return [value["timestamp"], +value["value"]];
}

const LedgerView = (props) => {
  let bal = [[100000, 0]];
  bal = props.data.getMadruhamSummary.tsBalance;

  bal.push({ timestamp: props.data.getMadruhamSummary.ts, value: props.data.getMadruhamSummary.balance });

  bal = bal.map(numerizeFloat);

  let tmp = [];
  if (bal.length == 0) {
    tmp = [[1000, 0.1]];
  } else {
    tmp = bal;
  }
  let apex_data = [{ data: tmp }];

  let { width, height } = useWindowSize();
  if (width > 565) {
    width = 565;
  } else {
    width = width - 35;
  }

  let apex_options = {
    colors: ["#0293cdff"],
    yaxis: {
      labels: {
        show: true,
        formatter: function (val) {
          return ~~val;
        },
      },
    },
    xaxis: {
      labels: {
        show: false,
      },
    },
    chart: {
      id: "area-datetime",
      type: "area",
      zoom: {
        autoScaleYaxis: true,
      },
      toolbar: {
        show: false,
      },
      tooltip: {
        enabled: false,
        show: false,
      },
    },

    dataLabels: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
      show: false,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.4,
        opacityTo: 0.0,
        stops: [0, 100],
        gradientToColors: ["#0293cdff"],
      },
    },
  };

  if (props.visibility == "FALSE") {
    apex_options = {
      colors: ["#0293cdff"],
      yaxis: {
        labels: {
          show: false,
        },
      },
      xaxis: {
        labels: {
          show: false,
        },
      },
      chart: {
        id: "area-datetime",
        type: "area",
        zoom: {
          autoScaleYaxis: true,
        },
        toolbar: {
          show: false,
        },
        tooltip: {
          enabled: false,
          show: false,
        },
      },

      dataLabels: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
        show: false,
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.4,
          opacityTo: 0.0,
          stops: [0, 100],
          gradientToColors: ["#0293cdff"],
        },
      },
    };
  }

  let _F = [];

  props.data.getMadruhamSummary.ledgerItems.map((ledgeritem) => {
    if (ledgeritem.amount < 0) {
      _F.push(<Ledgeritemnegative key={ledgeritem.ledger_id} data={ledgeritem} visibility={props.visibility}></Ledgeritemnegative>);
    } else {
      _F.push(<Ledgeritempositive key={ledgeritem.ledger_id} data={ledgeritem} visibility={props.visibility}></Ledgeritempositive>);
    }
  });

  async function remove_page() {
    if (props.page < 1) {
      props.set_page(0);
    } else {
      props.set_page(props.page - 1);
    }
  }

  async function add_page() {
    props.set_page(props.page + 1);
  }

  return (
    <div className={`ledgerview-container ${props.rootClassName} `}>
      <div className='ledgerview-ledgernamestrip'>
        <svg viewBox='0 0 1024 1024' className='ledgerview-ledgericon'>
          <path
            d='M469.333 469.333h-64c-29.483 0-56.064-11.904-75.435-31.232s-31.232-45.952-31.232-75.435 11.904-56.064 31.232-75.435 45.952-31.232 75.435-31.232h64zM554.667 554.667h64c29.483 0 56.064 11.904 75.435 31.232s31.232 45.952 31.232 75.435-11.904 56.064-31.232 75.435-45.952 31.232-75.435 31.232h-64zM725.333 170.667h-170.667v-128c0-23.552-19.115-42.667-42.667-42.667s-42.667 19.115-42.667 42.667v128h-64c-52.992 0-101.077 21.547-135.765 56.235s-56.235 82.773-56.235 135.765 21.547 101.077 56.235 135.765 82.773 56.235 135.765 56.235h64v213.333h-213.333c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667h213.333v128c0 23.552 19.115 42.667 42.667 42.667s42.667-19.115 42.667-42.667v-128h64c52.992 0 101.077-21.547 135.765-56.235s56.235-82.773 56.235-135.765-21.547-101.077-56.235-135.765-82.773-56.235-135.765-56.235h-64v-213.333h170.667c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667z'
            className=''></path>
        </svg>
        <span className='ledgerview-ledgername'>Finance</span>
      </div>
      <div className='ledgerview-ledgerchart'>
        <ErrorBoundary>
          <Chart options={apex_options} series={apex_data} type='area' height='100%' width={width} />
        </ErrorBoundary>
      </div>
      <div className='ledgerview-balancestrip'>
        <span className='ledgerview-ledgerbalanetext'>Balance:</span>
        {props.visibility == "TRUE" ? (
          <span className='ledgerview-balanceamounttext'>{numberWithCommas(props.data.getMadruhamSummary.balance) + " VT"}</span>
        ) : (
          <span
            className='ledgerview-balanceamounttext'
            style={{
              color: "transparent",
              textShadow: "0 0 16px #0099ccff",
            }}>
            {numberWithCommas(props.data.getMadruhamSummary.balance) + " VT"}
          </span>
        )}
      </div>
      <span className='ledgerview-ledgersmallprint'>BANK Transfers can take up to a week to appear in your Bank Accoun</span>
      <div className='ledgerview-ledgerhistorytopstrip'>
        <div></div>
        <div className='ledgerview-ledgerpagingtopbit'>
          <svg viewBox='0 0 1024 1024' className='ledgerview-topleftarrow' onClick={remove_page}>
            <path d='M658 708l-60 60-256-256 256-256 60 60-196 196z' className=''></path>
          </svg>
          <span className='ledgerview-toppageno'>{props.page + 1}</span>
          <svg viewBox='0 0 1024 1024' className='ledgerview-toprightarrow' onClick={add_page}>
            <path d='M366 708l196-196-196-196 60-60 256 256-256 256z' className=''></path>
          </svg>
        </div>
      </div>
      <div className='ledgerview-transactionlist'>{_F}</div>
      <div className='ledgerview-ledgerhistorybottomstrip'>
        <div className='ledgerview-ledgerpagerbottombit'>
          <svg viewBox='0 0 1024 1024' className='ledgerview-bottomleftarrow' onClick={remove_page}>
            <path d='M658 708l-60 60-256-256 256-256 60 60-196 196z' className=''></path>
          </svg>
          <span className='ledgerview-bottompageno'>{props.page + 1}</span>
          <svg viewBox='0 0 1024 1024' className='ledgerview-bottomrightarrow' onClick={add_page}>
            <path d='M366 708l196-196-196-196 60-60 256 256-256 256z' className=''></path>
          </svg>
        </div>
      </div>
    </div>
  );
};

LedgerView.defaultProps = {
  rootClassName: "",
};

LedgerView.propTypes = {
  rootClassName: PropTypes.string,
};

export default LedgerView;
